<template>
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">{{ _('User interface') }}</h4>
    </div>
    <div class="modal-body">
      <table class="ui-infotable">
        <tbody>
          <tr v-if="clientid">
            <td style="width: 150px">{{ _('Identifier') }}</td>
            <td><strong id="uiClientId">{{ clientid }}</strong></td>
            <td>
              <button class="btn btn-success pull-right" type="button" v-on:click="copyToClipboard(clientid)"><i class="fa fa-fw fa-clipboard"></i> {{ _('Copy to clipboard') }}</button>
            </td>
          </tr>
          <tr v-if="clientName">
            <td>{{ _('Name') }}</td>
            <td><strong>{{ clientName }} </strong>(ID {{ clientIdNumber }})</td>
          </tr>
          <tr v-if="pos">
            <td>{{ _('Point of use') }}</td>
            <td><strong v-if="currpos">{{ currpos.name }} </strong>(ID {{ pos }})</td>
          </tr>
          <tr v-if="userData">
            <td>{{ _('User') }}</td>
            <td><strong>{{ userData.name }} </strong>({{ userData.email }})</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="modal-footer">
      <button class="btn btn-default" v-on:click="hideModal"><i class="fa fa-fw fa-close"></i> {{ _('Close') }}</button>
      <button v-if="isChangeUiButtonVisible" class="pull-left btn btn-success" v-on:click="changeUi"><i class="fa fa-fw fa-object-ungroup"></i> {{ _('Change UI') }}</button>
      <!-- <button class="pull-left btn btn-info" v-on:click="switchVersion"><i class="fa fa-fw fa-flask"></i> {{ switchVersionText }}</button> --> 
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import errors from '~/lib/errors'

export default {
  data () {
    return {
      currpos: null
    }
  },
  mixins: [errors],
  props: ['baseDomain', 'localDomain', 'clustered', 'shopId', 'apiKey', 'clientid', 'pos', 'clientName', 'clientIdNumber', 'userData', 'isChangeUiButtonVisible'],
  computed: {
    isNewVersion () {
      return !!this.clustered
    },
    switchVersionText () {
      return this.isNewVersion ? this._('Return to old environment') : this._('Try the new environment')
    }
  },
  methods: {
    hideModal () {
      this.$emit('close')
    },
    switchVersion () {
      let targetDomain
      switch (this.localDomain) {
        case 'https://app.johku.com/':
          targetDomain = 'https://kube-app.johku.com/'
          break
        case 'https://kube-app.johku.com/':
          targetDomain = 'https://app.johku.com/'
          break
        case 'http://localhost:3030/':
          targetDomain = 'https://pos-marko.jalusta.com/'
          break
        case 'https://pos-marko.jalusta.com/':
          targetDomain = 'http://localhost:3030/'
          break
      }
      if (targetDomain) {
        const clientQuery = this.clientid ? '?clientid=' + encodeURIComponent(this.clientid) : ''
        window.location.href = targetDomain + this.shopId + '/' + clientQuery
      }
    },
    loadPos () {
      return new Promise(async (resolve) => {
        let response
        try {
          response = await axios.get(this.baseDomain + this.shopId + '/pos/' + this.pos + '.json?apikey=' + this.apiKey)
        } catch(e) {
          resolve(null)
          return
        }
        resolve(response.data)
      })
    },
    async copyToClipboard(data) {
      try {
        let status = await this.$copyText(data)
        this.showNotification(this._('Code copied to clipboard!'))
      } catch(e) {
        this.showError(e)
      }
    },
    changeUi () {
      this.$emit('changeUi')
    }
  },
  async mounted () {
    if (this.pos) {
      this.currpos = await this.loadPos(this.pos)
    }
  }
}
</script>

<style scoped>
.ui-infotable {
  width: 100%;
}
.ui-infotable td {
  height: 45px;
}
</style>